import Button from "@/components/common/Button";
import WebIcon from "@/components/common/Web_Icons";
import PropTypes from "prop-types";

const EmptyState = ({ onAddNew, message = "No Support Tickets Found" }) => {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg p-8 mt-6 max-w-[600px] mx-auto">
      <WebIcon
        icon="SupportHover"
        size="large"
        className="mb-6 w-[100px] h-[100px]"
      />
      <h2 className="mb-4 heading-medium font-bold text-lighterGrey">
        {message}
      </h2>
      <p className="mb-8 font-normal text-bold text-lighterGrey">
        {message.includes("search")
          ? "Try adjusting your search or filter criteria"
          : "Start by creating a new support ticket for assistance."}
      </p>
      {!message.includes("search") && (
        <Button
          text="CREATE NEW TICKET"
          color="primary"
          className="w-full px-6 py-3 font-medium text-white"
          customBgColor="primary"
          customTextColor="white"
          onClick={onAddNew}
        />
      )}
    </div>
  );
};

EmptyState.propTypes = {
  onAddNew: PropTypes.func,
  message: PropTypes.string,
};

export default EmptyState;
